// Header.jsx
/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import "../../assets/css/header.css";
import BottomBar from "../../components/ui/BottomBar/BottomBar";
import LanguageSwitcher from "../../components/ui/LanguageSwitcher/LanguageSwitcher";
import Notification from "../../features/notification/components/Notification/Notifcation";
import NotificationListModal from "../../features/notification/components/NotificationListModal/NotificationListModal";
import { useIsDesktop } from "../../hooks/useIsDesktop";
import { useUser } from "../../hooks/useUser";

const Header = ({ title, onBack, showIcon, showNotifications }) => {
  const { t } = useTranslation("header");
  const { userData } = useUser();

  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  const goToRegister = () => {
    navigate("/register");
  };

  const goToProfile = () => {
    navigate("/profile");
  };

  const handleNotificationClick = () => {
    navigate("/notifications");
  };

  const isDesktop = useIsDesktop();
  const goHome = () => {
    navigate("/");
  };

  return (
    <>
      <header className="main-header">
        <div className="tHead">
          {onBack && !isDesktop && (
            <a onClick={handleBack} className="back-button" href="#"></a>
          )}
          {showIcon && (
            <div className="bIcon icon">
              <div className="bCenter" onClick={goHome}>
                <img
                  alt="CTS"
                  className="bHeadIcon"
                  src="/assets/img/ci/icon/icon-aunjai.svg"
                />
              </div>

              <div className="bRight">
                {userData ? (
                  <>
                    {!isDesktop && (
                      <div className="bRight">
                        {/* Profile icon on mobile
                        <div className="desktop-button-bar-wrapper">
                          <Link className={styles.menu} to="/profile">
                            <Icon name="profile-pink" />
                          </Link>
                        </div> */}

                        {/* Notification icon on mobile, only if logged in */}
                        {showNotifications && userData && (
                          <div style={{ display: "flex", gap: 16 }}>
                            <div
                              className="mobile-notification"
                              onClick={handleNotificationClick}
                            >
                              <Notification />
                            </div>
                            <LanguageSwitcher />
                          </div>
                        )}
                      </div>
                    )}
                  </>
                ) : (
                  <div
                    style={{ display: "flex", alignItems: "center", gap: 16 }}
                  >
                    <button className="btnRegister" onClick={goToRegister}>
                      {t("login")}
                    </button>
                    {!isDesktop && <LanguageSwitcher />}
                  </div>
                )}

                {isDesktop && (
                  <div className="desktop-menu-wrapper">
                    <BottomBar />
                    {/* Notification icon on desktop, only if logged in */}
                    {showNotifications && userData && (
                      <div
                        onClick={handleNotificationClick}
                        className="notification"
                      >
                        <Notification />
                      </div>
                    )}
                    <LanguageSwitcher />
                  </div>
                )}
              </div>
            </div>
          )}
          {title !== "" && <h1>{title}</h1>}
        </div>
      </header>
    </>
  );
};

export default Header;
